export default "__VITE_ASSET__8ecb4c44__"